import { isPlatformAXA } from 'utils/showDetails';
import { AddTradingOfferPageContextType } from '../types/AddTradingOfferPageContextType';

export const addTradingOfferPageInitValue: AddTradingOfferPageContextType = {
  data: {
    tradingOfferType: null,
    actionType: '',
    partnerOptions: [],
    selectedPartnerOption: null,
    holdingClassOptions: [],
    selectedHoldingClassOption: null,
    partnerCurrentSharesCount: 0,
    sharesToTransfer: 0,
    maxSharesToTransfer: 0,
    isSellAllMyShares: false,
    isPartialAmountEnabled: false,
    minSharesPerAcceptance: 1,
    additionalNotes: '',
    price: isPlatformAXA ? 0.28246 : 0,
    isPricePerShare: true,
    pricePerShare: 0,
    totalOfferPrice: 0,
    startDate: '',
    endDate: '',
    societyId: '',
    societyName: '',
    isPartnerView: false,
    isAdmin: false,
    isReadOnly: false,
    isLoading: true,
    isLoadingReservedSellOffers: false,
    isMarketClosed: false,
  },
  actions: {
    handleChangePartner: () => {},
    handleSearchPartnerByTerm: async () => [],
    handleChangeHoldingClass: () => {},
    handleSearchHoldingClassByTerm: async () => [],
    handleChangeSharesToTransfer: () => {},
    handleChangeIsSellAllMyShares: () => {},
    handleChangeIsPartialAmountEnabled: () => {},
    handleChangeMinSharesPerAcceptance: () => {},
    handleChangeAdditionalNotes: () => {},
    handleChangePrice: () => {},
    handleChangeIsPricePerShare: () => {},
    handleChangeStartDate: () => {},
    handleChangeEndDate: () => {},
    handleSetDatePreset: () => {},
    handleReviewTradingOffer: () => {},
  },
};
